var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-div',{staticClass:"ma-2"},[_c('v-row',[_c('v-col',[_c('h1',{staticClass:"display-1 font-weight-bold"},[_vm._v(" Unauthorized ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }